<template>
  <div>
    <div class="flex mb-4" style="align-items: center;">
      <h5>안전점검일지</h5>
      <vs-spacer></vs-spacer>
      <vs-button color="secondary" @click="showApproval">결재 프로세스</vs-button>
    </div>
    <div style="margin-left:-1.2rem; margin-right:-1.2rem; padding:1.2rem; background: #fff;">
      <div class="flex mb-8" >
        <vs-button class="w-1/2 mr-2" color="secondary" type="border" @click="back">목록</vs-button>
        <vs-button class="w-1/2 ml-2" color="secondary" @click="handleClickRegister">임시저장</vs-button>
      </div>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>기본정보</h5></vs-col>
      </vs-row>

      <vs-row class="mb-4 flex flex-wrap" >
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">{{ $t('project.risk.check.checklog-always.create.사무소명') }}</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="projectInfo.field_name" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title pr-4 ">차수</vs-col>
          <vs-col class="w-9/12">
            <order-number-select-module class="w-full" v-model="form.orderNumber" :disabled="true" @handleChange="handleChangeOrderNumber"/>
          </vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">대상기간</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.date" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title ">소속</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.com_name" :readonly="true" /></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">점검일</vs-col>
          <vs-col class="w-9/12"><date-selector class="w-full" v-model="form.checkDate"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title pr-4">작성자</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.writer" :readonly="true" /></vs-col>
        </vs-row>
      </vs-row>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>주요작업 및 위험작업</h5></vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <vs-textarea
            class="w-full"
            rows="5"
            v-model="form.comment1"
          />
        </vs-col>
      </vs-row>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>중점 점검항목 - A등급</h5></vs-col>
      </vs-row>

      <vs-row class="mb-8">
        <vs-col class="border" style="overflow-x: auto;">
          <ul class="table" >
            <li style="display: flex;">
              <p style="min-width:60px;">No.</p>
              <p style="min-width:150px;">소속</p>
              <p style="min-width:150px;">대상공종</p>
              <p style="min-width:150px;">위치/장소</p>
              <p style="min-width:150px;">위험요인</p>
              <p style="min-width:150px;">재해형태</p>
              <p style="min-width:150px;">안전보건대책</p>
              <p style="min-width:150px;">안전대책이행</p>
              <p style="min-width:60px;">점검결과 조치사항</p>
            </li>
            <li class="tbody" style="display: flex;" v-for="(item, index) in list1" :key="index" @click="()=>{handleSelectItem(item)}">
              <p class="p-2" style="min-width:60px; max-width:60px;">{{index}}</p>
              <p class="p-2" style="min-width:150px; max-width:150px;">파트너사 </p>
              <p class="p-2" style="min-width:150px; max-width:150px;">대상공종 {{item.work_unit}}  </p>
              <p class="p-2" style="min-width:150px; max-width:150px;">위치/장소 </p>
              <p class="p-2" style="min-width:150px; max-width:150px;">{{item.risk_factor}}</p>
              <p class="p-2" style="min-width:150px; max-width:150px;">{{item.disaster_type}}</p>
              <p class="p-2" style="min-width:150px; max-width:150px;">{{item.safety_measures}}</p>
              <p class="p-2" style="min-width:150px; max-width:150px;">
                <vs-select autocomplete class="w-full" v-model="item.exe" :disabled="true">
                  <vs-select-item text="Y" value="Y"/>
                  <vs-select-item text="N" value="N"/>
                </vs-select>
              </p>
              <p class="p-2 text-center" style="min-width:60px; max-width:60px; cursor: pointer" @click="showPopupUploadImages" >
                <vs-icon class="ml-4 mr-2" icon-pack="feather" icon="icon-camera" size="small" />
              </p>
            </li>
          </ul>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col class="">
          <h5 class="mb-4"><i class="dot"></i>일상 점검항목-B,C 등급</h5>
        </vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col class="border" style="overflow-x: auto;">
          <ul class="table" >
            <li style="display: flex;">
              <p style="min-width:60px;">No.</p>
              <p style="min-width:150px;">소속</p>
              <p style="min-width:150px;">대상공종</p>
              <p style="min-width:150px;">위치/장소</p>
              <p style="min-width:150px;">위험요인</p>
              <p style="min-width:150px;">재해형태</p>
              <p style="min-width:150px;">안전보건대책</p>
              <p style="min-width:150px;">안전대책이행</p>
              <p style="min-width:60px;">점검결과 조치사항</p>
            </li>
            <li class="tbody" style="display: flex;" v-for="(item, index) in list2" :key="index" @click="()=>{handleSelectItem(item)}">
              <p class="p-2" style="min-width:60px; max-width:60px;">{{index}}</p>
              <p class="p-2" style="min-width:150px; max-width:150px;">파트너사 </p>
              <p class="p-2" style="min-width:150px; max-width:150px;">대상공종 {{item.work_unit}}  </p>
              <p class="p-2" style="min-width:150px; max-width:150px;">위치/장소 </p>
              <p class="p-2" style="min-width:150px; max-width:150px;">{{item.risk_factor}}</p>
              <p class="p-2" style="min-width:150px; max-width:150px;">{{item.disaster_type}}</p>
              <p class="p-2" style="min-width:150px; max-width:150px;">{{item.safety_measures}}</p>
              <p class="p-2" style="min-width:150px; max-width:150px;">
                <vs-select autocomplete class="w-full" v-model="item.exe" :disabled="true">
                  <vs-select-item text="Y" value="Y"/>
                  <vs-select-item text="N" value="N"/>
                </vs-select>
              </p>
              <p class="p-2 text-center" style="min-width:60px; max-width:60px; cursor: pointer" @click="showPopupUploadImages" >
                <vs-icon class="ml-4 mr-2" icon-pack="feather" icon="icon-camera" size="small" />
              </p>
            </li>
          </ul>
        </vs-col>
      </vs-row>

      <file-upload-module class="w-full mt-8" :is-show-title="true" type="check_list_col" id="bottom" v-model="fileList"/>


    </div>


    <vs-row :class="isShowApproval?'':'hidden'" style="position:fixed; top:0; left:0; bottom:0; right:0; z-index:45000; background: rgba(0,0,0,0.7); ">
      <div style="position: relative; width: 100%; height:100%; display: grid; grid-template-rows: 110px; minmax(0%,100%); overflow-y: auto;">
        <vs-spacer @click="hideApproval"></vs-spacer>

        <approval-process-module
          class="h-full"
          :board = "board"
          :commentabled="!(board.isCompleteApproval || board.savable)"

          @handleClickUpload="handleClickUpload"
          @handleClickOk="handleClickOk"
          @handleClickNo="handleClickNo"
          @handleSendApprovalProcess = "handleSendApprovalProcess"
        ></approval-process-module>
        <a style="width:33px; height:33px; position:absolute; top:77px; right:10px;"  @click="hideApproval">
          <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="background: rgb(255, 255, 255);">close</i>
        </a>
      </div>

    </vs-row>


    <vs-row :class="selectItem.is_checked?'':'hidden'" style="position:fixed; top:0; left:0; bottom:0; right:0; z-index:45000; background: rgba(0,0,0,0.7); ">
      <div style="position: relative; width: 100%; height:100%; display: grid; grid-template-rows: 110px; minmax(0%,100%); overflow-y: auto;">
        <vs-spacer @click="handleClose"></vs-spacer>

        <work-detail-module
          v-model="selectItem"
          :enableClose="false"

          @handleClickFileUpload = "handleClickFileUpload"
          @handleClose = "handleClose"
        >
        </work-detail-module>
        <a style="width:33px; height:33px; position:absolute; top:77px; right:10px;"  @click="handleClose">
          <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="background: rgb(255, 255, 255);">close</i>
        </a>
      </div>

    </vs-row>

    <vs-popup id="popupAddProjectMember" title="사진업로드" :active.sync="popupUploadImage" >
      <div>
        <file-upload-module  type="check_list_col" v-model="selectItem.fileList"></file-upload-module>
      </div>
    </vs-popup>

    <!-- TODO : 얼럿데이터 -->
    <popup-alert v-model="alert.show"
                 :message="alert.message"
                 :buttons="alert.buttons"

                 @upload="alertUpload"/>
  </div>
</template>

<script>
import OrderNumberSelectModule from '@/views/modules/OrderNumberSelectModule'
import DateSelector from '@/views/components/DateSelector'
import FileUploadModule from '@/views/modules/FileUploadModule'
import ApprovalProcessModule from '@/views/modules/ApprovalProcessModule'
import WorkDetailModule from '@/views/modules/WorkDetailModule'
import PopupAlert from '@/views/components/popup/PopupAlert'
export default {
  name: 'MobileSafetyDailyCheckLogCreate',
  components: {
    PopupAlert,
    WorkDetailModule,
    ApprovalProcessModule,
    FileUploadModule,
    DateSelector,
    OrderNumberSelectModule},
  data () {
    return {
      boardSlug: 'daily_safety_check_diary',
      selectItem:{},

      // TODO : 글쓰기 정보 및 권한
      board:{
        slug:'daily_safety_check_diary',
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine:[], // 결재라인
        commentList:[] // 댓글리스트
      },

      // TODO : 얼럿데이터
      alert:{
        show:false,
        message:'결재하시겠습니까?',
        buttons:[
          { label:'승인', action:'ok' },
          { label:'취소', action:'cancel' }
        ]
      },
      approvalLine:[], // 결재선 등록

      popupUploadImage:false,
      isShowApproval:false,

      list1:[],
      list2:[],

      form:{
        project_title:'', //사무소명
        writer:'', //작성자
        com_name:'',
        date:'', //대상기간
        sdate:'',
        edate:'',
        orderNumberId:'', //차수
        orderNumber:'', //차수
        checkDate:'', //점검일

        comment1:'', // 주요작업 및 위험작업
        comment2:'', // 현장점검내용(이슈사항, 합동점검,특별작업 등)
        attach:{}, //첨부
        list1:[], //확인점검내용
        list2:[], //일상 위험관리

        // preview
        preview: {
          title: '',
          orderNumber: '',
          date: '',
          checkDate:'',
          writer:''
        }
      },
      fileList:[] //파일리스트
    }
  },

  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    },
    disasterList () {
      const list = this.$store.state.approval.disasterTypeList
      const returnList = []
      for (const item of list) {
        returnList.push({
          text:item.name,
          value:item.id
        })
      }
      return returnList
    }
  },

  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {

      if (JSON.stringify(this.oldForm) === JSON.stringify(this.form)) {
        next(true)
      } else if (confirm('저장하지 않은 데이터는 삭제됩니다. 닫으시겠습니까?')) {
        next(true)
      }

    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })

    this.$store.dispatch('approval/LOAD_DISASTER_TYPE_LIST', {})
  },

  created () {
    this.init()
  },

  methods: {
    back () {
      this.$router.back()
    },

    async init () {
      await this.$store.dispatch('USER_INFO')
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        company_name: this.$store.state.auth.userInfo.company_name
      }

      await this.$store.dispatch('company/LOAD_COMPANY', {companyId:this.board.writer.company_id})
      this.board.writer.company_name = this.$store.state.company.companyInfo.com_name

      const company = this.$store.state.project.projectInfo.constructor_company
      this.form.writer = this.board.writer.name
      this.form.com_name = this.board.writer.company_name
      this.form.project_title = this.$store.state.project.projectInfo.field_name
      this.form.company = (company) ? company.com_name : ''

      this.oldForm = JSON.parse(JSON.stringify(this.form))
    },

    async register (isUploaded) {
      if (isUploaded && (!this.approvalLine || this.approvalLine.length === 0)) {
        alert('결재선을 지정해주세요')
        return
      }

      // 등록정보
      const boardSlug = this.boardSlug
      const title = this.projectInfo.field_name
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))
      const security = 'normal' // 문서보안 등급 ['일반', 대외비 1급, 대외비 2급, 인비, 극비] [normal,confidential1,confidential2,personally,confidential0]
      const priority = 'medium' // 문서 중요도 [매우낮음, 낮음, 보통, 높음, 매우 높음] [lowest,low,medium,high,highest]
      const projectId = this.$route.params.proj_id
      const projectOrderId = this.orderNumberId

      let uploads = ''
      const listUploads = []
      const uploadFileIds = []

      if (this.fileList.length > 0) {
        for (const file of this.fileList) {
          listUploads.push(file)
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      this.form.list1 = this.list1
      this.form.list2 = this.list2
      this.form.preview.title = this.projectInfo.field_name
      this.form.preview.orderNumber = this.form.orderNumber
      this.form.preview.date = this.form.date
      this.form.preview.checkDate = this.form.checkDate
      this.form.preview.writer = this.form.writer
      const content = JSON.stringify(this.form)

      try {
        if (isUploaded) {
          // 바로 상신하기
          await this.$store.dispatch('approval/CREATE_POST', {boardSlug, title, content, approvalLine, security, priority, uploads, projectId, projectOrderId})
          alert('상신되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        } else {
          // 임시 저장하기
          const isTemp = 1
          await this.$store.dispatch('approval/CREATE_POST', {boardSlug, title, content, approvalLine, security, priority, uploads, projectId, projectOrderId, isTemp})
          alert('임시저장되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        }

      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
        } else {
        }
      }

    },

    // TODO : 결재프로세스
    // ApprovalProcessModule 에서 사용하는 line 방식에서 전송용 line 으로 변경
    lineToSendLine (data) {
      const approvalList = []

      for (const member of data) {
        if (member.type_code !== 'register') {
          approvalList.push({
            id : member.user_id,
            name : member.user_name,
            elementType : member.type_code
          })
        }
      }

      return approvalList
    },

    handleClickRegister () {
      if (confirm('저장하시겠습니까?')) {
        this.register(false)
      }
    },

    async handleChangeOrderNumber (data) {
      if (this.form.orderNumber !== data.order_number) {

        this.form.orderNumberId = data.id
        this.form.orderNumber = data.order_number
        this.form.sdate = data.begin_ymd.substr(0, 10)
        this.form.edate = data.end_ymd.substr(0, 10)
        this.form.date = `${this.form.sdate} ~ ${this.form.edate}`

        // 정기위험성평가 불러오기
        await this.loadChecklist(data.order_number)
      }
    },

    async loadChecklist (order_number) {
      const projectId = this.$route.params.proj_id
      const boardId = 43
      const page = 1
      const perPage = 100
      const orderTarget = 'created_at'
      const orderDirection = 'desc'
      const keyword = []
      keyword.push(`contentd$preview.orderNumber*${order_number}`)

      await this.$store.dispatch('board/LOAD_POST_LIST', {projectId, boardId, page, perPage, keyword, orderTarget, orderDirection})
      const postListInfo = this.$store.state.board.postListInfo

      const post = JSON.parse(postListInfo.data[0].post_content)
      this.list1 = post.list1
      this.list2 = post.list2

      for (let i = 0; i < this.list1.length; i++) {
        this.list1[i].listType = 'list1'
        this.list1[i].num = i
        this.list1[i].fileList = []
      }

      for (let i = 0; i < this.list2.length; i++) {
        this.list2[i].listType = 'list2'
        this.list2[i].num = i
        this.list2[i].fileList = []
      }

    },

    // TODO : 얼럿데이터
    alertUpload () {
      this.register(true)
    },

    handleSelectItem (item) {
      if (this.selectItem) {
        this.selectItem.is_checked = false
      }

      this.selectItem = item
      this.selectItem.is_checked = true
      this.selectItem.orderNumber = this.form.orderNumber
    },

    handleClose () {
      this.selectItem = {}
    },

    showPopupUploadImages () {
      this.popupUploadImage = true
    },

    handleClickFileUpload () {
      this.popupUploadImage = true
    },

    handleSendApprovalProcess (process) {
      this.approvalLine = process
    },

    handleClickUpload () {
      this.alert.buttons = [
        { label:'상신', action:'upload' },
        { label:'취소', action:'cancel', type:'border' }
      ]
      this.alert.show = true

    },
    handleClickOk () {

    },
    handleClickNo () {

    },

    showApproval () {
      this.isShowApproval = true
    },

    hideApproval () {
      this.isShowApproval = false
    },

    getDisasterName (value) {
      for (const disaster of this.disasterList) {
        if (`${disaster.value}` === `${value}`) {
          return disaster.text
        }
      }

      return ''
    }

  }
}
</script>

<style scoped>
.bc-grade li:nth-child(2n+1) {
  background: #fafafa;
}
</style>
